import dateDiff from '@helpers/dateDiff';
import getValorAproximado from '@helpers/getValorAproximado';
import intToReal from '@helpers/intToReal';
import getFormattedResult from '@helpers/getFormattedResult';
import formatDate from '@helpers/formatDate';
import LotteriesEnum from '@data/lotteries';
import moment from 'moment';
moment.locale('pt-br')

class Draw {
  constructor (data) {
    data = data || {}

    this.drawID = data.drawID || null
    this.lotteryID = data.lotteryID || null
    this.drawNumber = data.drawNumber || 0
    this.drawDate = data.drawDate || null
    this.drawDateText = null
    this.drawDateTextLong = null
    this.isEspecial = data.isEspecial || false
    this.isJackpot = data.isEspecial ? false : data.isJackpot || false
    this.estimatedPrize = data.estimatedPrize || 0
    this.estimatedPrizeReal = intToReal(this.estimatedPrize, false)
    this.estimatedPrizeText = this.estimatedPrize
      ? getValorAproximado(this.estimatedPrize)
      : 'A Definir'
    this.footballScheme = data.footballScheme || false
    this.warnings = data.warnings || []
    this.hasCustomGameAvailable = data.hasCustomGameAvailable || false
    this.hasProductsAvailable = data.hasProductsAvailable || false
    this.drawResults = data.drawResults || null
    this.gameType = 'bets'
    this.hasOffers = data.hasOffers || false

    const lottery = LotteriesEnum.find((lot) => lot.id === this.lotteryID)

    if (lottery) {
      this.gameType = lottery.gameType
    }

    if (!this.drawDate) {
      this.drawDateText = 'A Definir'
      this.drawDateTextLong = 'A Definir'
      this.drawWeekDay = 'A Definir'
    } else {
      const today = moment().endOf('day')
      const endOfDayDrawDate = moment(new Date(this.drawDate)).endOf('day');
      const diff = dateDiff(endOfDayDrawDate, today);

      switch (diff) {
        case 0:
          this.drawDateText = 'Hoje'
          this.drawDateTextLong = 'Hoje'
          this.drawWeekDay = 'Hoje'
          break
        case 1:
          this.drawDateText = 'Amanhã'
          this.drawDateTextLong = 'Amanhã'
          this.drawWeekDay = formatDate(this.drawDate, 'dddd')
          break
        default:
          this.drawDateText = formatDate(this.drawDate, 'DD/MM')
          this.drawDateTextLong = formatDate(this.drawDate, 'DD/MM/YYYY')
          this.drawWeekDay = formatDate(this.drawDate, 'dddd')
          break
      }
    }
    // Desdobramento de tratamento APENAS para Mais Milionaria
    if (this.lotteryID === 12 && this.drawResults?.length) {
      const drawResults = [];
      const rawResult = (this.drawResults[0].result || '').split(' - ');

      drawResults[0] = {
        ...this.drawResults[0],
        result: rawResult[0] || ''
      }

      drawResults[1] = {
        result: rawResult[1] || '',
        raffleNumber: 2,
        drawPrizes: []
      }
      this.drawResults = drawResults;
    }
    if (this.drawResults) {
      this.drawResults.forEach((drawResult) => {
        drawResult.resultFormatted = getFormattedResult(
          drawResult.result,
          this.gameType
        )
      })
    }
  }
}

export default Draw;
